import axios from 'axios'

export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const getNextMemberId = async () => {
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/members-next-id`);
    if (!data?.nextMemberId) {
      return '9000';
    }
    return data.nextMemberId;
  } catch (error) {
    return '9000';
  }
};